let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iFpaX")).then(() => parcelRequire('fYpdX'));